export const rankingTrend = [
  { day: "周一", top1: 8.4, top2: 8.1, top3: 7.8 },
  { day: "周二", top1: 8.7, top2: 8.4, top3: 8.0 },
  { day: "周三", top1: 8.9, top2: 8.8, top3: 8.3 },
  { day: "周四", top1: 9.1, top2: 9.0, top3: 8.5 },
  { day: "周五", top1: 9.3, top2: 9.1, top3: 8.6 },
  { day: "周六", top1: 9.5, top2: 9.2, top3: 8.8 },
  { day: "周日", top1: 9.6, top2: 9.4, top3: 9.0 },
];

export const rankingHighlights = [
  {
    icon: "ri-arrow-up-double-line",
    label: "本周上升最快",
    value: "《群聊里发错的那张图》",
    desc: "一周内群众打分从 7.6 升至 8.4，连升 5 位。",
  },
  {
    icon: "ri-arrow-down-double-line",
    label: "本周回落最多",
    value: "《拍摄现场道具穿帮合集》",
    desc: "受同期新入围作品影响，评分回落至 8.8。",
  },
  {
    icon: "ri-star-smile-line",
    label: "口碑最稳",
    value: "《凌晨三点的办公室灯光》",
    desc: "连续五天稳居榜首，差评率低于 2%。",
  },
];